export const FIRMWARE_STORE_API_KEY = 'firmwareApi';
export const FIRMWARE_GET_LIST_API = '/firmware';
